export const handleDownloadSvg = (
  svgRef: React.RefObject<SVGSVGElement>,
  withName: string,
) => {
  if (!svgRef.current) return;

  const serializer = new XMLSerializer();
  const source = serializer.serializeToString(svgRef.current);
  const blob = new Blob([source], { type: "image/svg+xml" });
  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = withName;
  a.click();

  URL.revokeObjectURL(url);
  a.remove();
};
